import { useAtom } from "jotai";
import { textStyles } from "../../styles/typography";
import { ccn, cn } from "../../styles/utils";
import Button from "../ui/Button";
import {
  BeachAccessIcon,
  CaretIcon,
  CheckFilledIcon,
  CloseIcon,
} from "../ui/icons";
import TextField from "../ui/TextField";
import { promoCodeAtom } from "./store";
import { useState } from "react";
import * as RxCollapsible from "@radix-ui/react-collapsible";

export default function PromoCodeCollapsible() {
  const [open, setOpen] = useState(false);
  const [promoCode, setPromoCode] = useAtom(promoCodeAtom);
  const [promoCodeInput, setPromoCodeInput] = useState(
    promoCode?.submittedCode ?? "",
  );

  return (
    <RxCollapsible.Root
      className="border rounded-lg border-blue-dark20"
      onOpenChange={setOpen}
      open={open}
    >
      <RxCollapsible.Trigger className="flex justify-between gap-2 px-3 py-4 w-full">
        <div className="flex gap-2">
          <BeachAccessIcon className="fill-blue-dark align-middle" />
          <h3
            className={cn(
              textStyles.body1,
              "text-blue-dark font-semibold tracking-tight",
            )}
          >
            Have A Promo Code?
          </h3>
        </div>
        <CaretIcon className={ccn("fill-blue-dark", open && "rotate-180")} />
      </RxCollapsible.Trigger>
      <RxCollapsible.Content className="px-3 flex flex-col gap-3">
        <div className="flex gap-2 items-start">
          <TextField
            value={promoCodeInput}
            error={promoCode?.error}
            onChange={(e) => {
              setPromoCodeInput(e.target.value);
              if (promoCode)
                // this will reset error messages on input
                setPromoCode(null);
            }}
            placeholder="Enter promo code"
            name="promoCode"
            disabled={!!promoCode?.submittedCode}
          />
          <Button
            type="submit"
            variant="secondary"
            onClick={() => {
              if (promoCode?.submittedCode) {
                setPromoCode(null);
                return;
              }
              setPromoCode({ submittedCode: promoCodeInput });
            }}
            icon={
              promoCode?.submittedCode ? (
                <CloseIcon className="fill-blue-dark" />
              ) : (
                <CheckFilledIcon className="fill-blue-dark" />
              )
            }
          >
            {promoCode?.submittedCode ? "Remove" : "Apply"}
          </Button>
        </div>
        {!promoCode?.isLoading && promoCode?.submittedCode && (
          <p
            className={cn(textStyles.text2, "text-green-primary !font-medium")}
          >
            Promo Code applied!
          </p>
        )}
        <p className="font-sans text-xs/5 text-blue-dark60 tracking-wider pb-3">
          Note: Promo code only applies to the boat price, not additional
          services or fees.
        </p>
      </RxCollapsible.Content>
    </RxCollapsible.Root>
  );
}
